// eslint-disable-next-line no-unused-vars
import axios from 'axios'
// eslint-disable-next-line no-unused-vars
import { config, url } from '@/store/index'
import router from '@/router'

const state = () => ({
  contractor: {
    legal_form: { id: null, name: '' },
    name: '',
    fullName: '',
    status: { id: null, name: '' },
    registrationAddress: '',
    actualAddress: '',
    type: { id: null, name: '' },
    inn: '',
    okpo: '',
    ogrn: '',
    contactInfo: '',
    contactPhone: '',
    contactEmail: '',
    contactPosition: '',
    contactUrl: '',
    contactRequisites: '',
    ptoDefault: null
  },
  statusOptionList: [],
  formOptionList: [],
  typeOptionList: [],
  validation: {
    name: { type: null, message: '' },
    fullName: { type: null, message: '' },
    type: { type: null, message: '' },
    status: { type: null, message: '' },
    inn: { type: null, message: '' },
    ogrn: { type: null, message: '' },
    okpo: { type: null, message: '' }
  },
  isLoading: true
})

const getters = {
  getContractorForUpdate: state => state.contractor,
  getContractorUpdateValidation: state => state.validation,
  getContractorUpdateIsLoading: state => state.isLoading,
  getContractorStatusList: state => state.statusOptionList,
  getContractorFormList: state => state.formOptionList,
  getContractorTypeList: state => state.typeOptionList
}

const mutations = {
  GET_CONTRACTOR: (state, contractor) => {
    state.contractor = contractor
  },
  GET_CONTRACTOR_FOR_UPDATE: (state, contractor) => {
    state.contractor = {
      ...contractor,
      legal_form: contractor.legal_form ? {
        name: contractor.legal_form.full_name,
        id: contractor.legal_form.id
      } : null,
      status: contractor.status ? {
        name: contractor.status.name,
        id: contractor.status.id
      } : null,
      partner_type_id: contractor.partner_type ? contractor.partner_type_id : null,
      partner_type: contractor.partner_type ? {
        name: contractor.partner_type.name,
        id: contractor.partner_type.id
      } : null,
      name: contractor.short_name,
      fullName: contractor.long_name,
      contactRequisites: contractor.checking_info,
      ptoDefault: contractor.pto_default
    }
    state.isLoading = false
  },
  GET_CONTRACTOR_STATUSES_LIST: (state, status) => {
    state.statusOptionList = status.data.map(status => {
      return {
        ...status
      }
    })
  },
  GET_CONTRACTOR_FORMS_LIST: (state, form) => {
    state.formOptionList = form.data.map(form => {
      return {
        name: form.full_name,
        id: form.id
      }
    })
  },
  GET_CONTRACTOR_TYPES_LIST: (state, type) => {
    state.typeOptionList = type.data.map(type => {
      return {
        ...type
      }
    })
  },
  SET_CONTRACTOR_UPDATE_FORM: (state, form) => {
    state.contractor.legal_form = form
  },
  SET_CONTRACTOR_UPDATE_NAME: (state, value) => {
    state.contractor.name = value
  },
  SET_CONTRACTOR_UPDATE_FULL_NAME: (state, value) => {
    state.contractor.fullName = value
  },
  SET_CONTRACTOR_UPDATE_STATUS: (state, status) => {
    state.contractor.status = status
  },
  SET_CONTRACTOR_UPDATE_REGISTRATION_ADDRESS: (state, value) => {
    state.contractor.registrationAddress = value
  },
  SET_CONTRACTOR_UPDATE_ACTUAL_ADDRESS: (state, value) => {
    state.contractor.actualAddress = value
  },
  SET_CONTRACTOR_UPDATE_TYPE: (state, type) => {
    state.contractor.type = type
  },
  SET_CONTRACTOR_UPDATE_INN: (state, value) => {
    state.contractor.inn = value
  },
  SET_CONTRACTOR_UPDATE_OKPO: (state, value) => {
    state.contractor.okpo = value
  },
  SET_CONTRACTOR_UPDATE_OGRN: (state, value) => {
    state.contractor.ogrn = value
  },
  SET_CONTRACTOR_UPDATE_CONTACT_INFO: (state, value) => {
    state.contractor.contactInfo = value
  },
  SET_CONTRACTOR_UPDATE_CONTACT_PHONE: (state, value) => {
    state.contractor.contactPhone = value
  },
  SET_CONTRACTOR_UPDATE_CONTACT_EMAIL: (state, value) => {
    state.contractor.contactEmail = value
  },
  SET_CONTRACTOR_UPDATE_CONTACT_POSITION: (state, value) => {
    state.contractor.contactPosition = value
  },
  SET_CONTRACTOR_UPDATE_CONTACT_URL: (state, value) => {
    state.contractor.contactUrl = value
  },
  SET_CONTRACTOR_UPDATE_CONTACT_REQUISITES: (state, value) => {
    state.contractor.contactRequisites = value
  },
  SET_CONTRACTOR_UPDATE_PTO_DEFAULT: (state, value) => {
    state.contractor.ptoDefault = value
  },

  SET_CONTRACTOR_ITEM_VALIDATION: (state, valid) => {
    if (valid?.long_name) {
      state.validation.fullName.message = valid.long_name[0]
      state.validation.fullName.type = 'error'
    }
    if (valid?.short_name) {
      state.validation.name.message = valid.short_name[0]
      state.validation.name.type = 'error'
    }
    if (valid?.partner_type_id) {
      state.validation.type.message = valid.partner_type_id[0]
      state.validation.type.type = 'error'
    }
    if (valid?.status_id) {
      state.validation.status.message = valid.status_id[0]
      state.validation.status.type = 'error'
    }
    if (valid?.inn) {
      state.validation.inn.message = valid.inn[0]
      state.validation.inn.type = 'error'
    }
    if (valid?.ogrn) {
      state.validation.ogrn.message = valid.ogrn[0]
      state.validation.ogrn.type = 'error'
    }
    if (valid?.okpo) {
      state.validation.okpo.message = valid.okpo[0]
      state.validation.okpo.type = 'error'
    }
  },

  CONTRACTOR_UPDATE_CLEAR_VALIDATION: (state, inputName) => {
    // свитч кейсом очищать валидацию в нужном поле по имени инпута
    switch (inputName) {
      case 'name':
        state.validation.name = { type: null, message: '' }
        break
      case 'type':
        state.validation.type = { type: null, message: '' }
        break
      case 'fullName':
        state.validation.fullName = { type: null, message: '' }
        break
      case 'status':
        state.validation.status = { type: null, message: '' }
        break
      case 'inn':
        state.validation.inn = { type: null, message: '' }
        break
      case 'okpo':
        state.validation.okpo = { type: null, message: '' }
        break
      case 'ogrn':
        state.validation.ogrn = { type: null, message: '' }
        break
      default:
        break
    }
  },

  SET_CONTRACTOR_UPDATE_INITIAL_STATE: (state) => {
    state.contractor = {
      legal_form: { id: null, name: '' },
      name: '',
      fullName: '',
      status: { id: null, name: '' },
      registrationAddress: '',
      actualAddress: '',
      type: { id: null, name: '' },
      inn: '',
      okpo: '',
      ogrn: '',
      contactInfo: '',
      contactPhone: '',
      contactEmail: '',
      contactPosition: '',
      contactUrl: '',
      contactRequisites: ''
    }
  },

  RESET_FORM_CONTRACTOR (state) {
    state.validation = {
      name: { type: null, message: '' },
      fullName: { type: null, message: '' },
      type: { type: null, message: '' },
      status: { type: null, message: '' },
      inn: { type: null, message: '' },
      ogrn: { type: null, message: '' },
      okpo: { type: null, message: '' }
    }
  }
}

const actions = {
  getContractorUpdateInfo ({ commit, state }, id) {
    const expands = 'expand=status, type, legal_form'

    axios.get(`${url}/partner/${id}?${expands}`, config).then(response => {
      commit('GET_CONTRACTOR_FOR_UPDATE', response.data.data)
    }).catch(error => {
      console.log('ошибка получения списка документы', error)
    })
  },
  contractorUpdateSetForm ({ commit }, form) {
    commit('SET_CONTRACTOR_UPDATE_FORM', form)
  },
  contractorUpdateSetName ({ commit }, value) {
    commit('SET_CONTRACTOR_UPDATE_NAME', value)
  },
  contractorUpdateSetFullName ({ commit }, value) {
    commit('SET_CONTRACTOR_UPDATE_FULL_NAME', value)
  },
  contractorUpdateSetStatus ({ commit }, status) {
    commit('SET_CONTRACTOR_UPDATE_STATUS', status)
  },
  contractorUpdateSetRegistrationAddress ({ commit }, value) {
    commit('SET_CONTRACTOR_UPDATE_REGISTRATION_ADDRESS', value)
  },
  contractorUpdateSetActualAddress ({ commit }, value) {
    commit('SET_CONTRACTOR_UPDATE_ACTUAL_ADDRESS', value)
  },
  contractorUpdateSetType ({ commit }, value) {
    commit('SET_CONTRACTOR_UPDATE_TYPE', value)
  },
  contractorUpdateSetINN ({ commit }, value) {
    commit('SET_CONTRACTOR_UPDATE_INN', value)
  },
  contractorUpdateSetOKPO ({ commit }, value) {
    commit('SET_CONTRACTOR_UPDATE_OKPO', value)
  },
  contractorUpdateSetOGRN ({ commit }, value) {
    commit('SET_CONTRACTOR_UPDATE_OGRN', value)
  },
  contractorUpdateSetContactInfo ({ commit }, value) {
    commit('SET_CONTRACTOR_UPDATE_CONTACT_INFO', value)
  },
  contractorUpdateSetContactPhone ({ commit }, value) {
    commit('SET_CONTRACTOR_UPDATE_CONTACT_PHONE', value)
  },
  contractorUpdateSetContactEmail ({ commit }, value) {
    commit('SET_CONTRACTOR_UPDATE_CONTACT_EMAIL', value)
  },
  contractorUpdateSetContactPosition ({ commit }, value) {
    commit('SET_CONTRACTOR_UPDATE_CONTACT_POSITION', value)
  },
  contractorUpdateSetContactUrl ({ commit }, value) {
    commit('SET_CONTRACTOR_UPDATE_CONTACT_URL', value)
  },
  contractorUpdateSetContactRequisites ({ commit }, value) {
    commit('SET_CONTRACTOR_UPDATE_CONTACT_REQUISITES', value)
  },
  contractorUpdateSetPtoDefault ({ commit }, value) {
    commit('SET_CONTRACTOR_UPDATE_PTO_DEFAULT', value)
  },

  contractorUpdateClearValidation ({ commit }, inputName) {
    commit('CONTRACTOR_UPDATE_CLEAR_VALIDATION', inputName)
  },
  contractorUpdateSaveInfo ({ commit, state }, id) {
    const contractorData = {
      status_id: state.contractor.status?.id,
      short_name: state.contractor.name,
      long_name: state.contractor.fullName,
      legal_address: state.contractor.registrationAddress,
      actual_address: state.contractor.actualAddress,
      site_url: state.contractor.contactUrl,
      inn: state.contractor.inn,
      okpo: state.contractor.okpo,
      ogrn: state.contractor.ogrn,
      contact_fullname: state.contractor.contactInfo,
      contact_position: state.contractor.contactPosition,
      contact_phone: state.contractor.contactPhone,
      contact_email: state.contractor.contactEmail,
      partner_type_id: state.contractor.type?.id,
      legal_form_id: state.contractor.legal_form?.id,
      checking_info: state.contractor.contactRequisites,
      pto_default: state.contractor.ptoDefault
    }
    if (id === 'create') {
      axios.post(`${url}/partner`, contractorData, config).then(response => {
        router.push({ name: 'ContractorList' })
      }).catch(error => {
        commit('SET_CONTRACTOR_ITEM_VALIDATION', error.response.data.validation)
        console.log('Ошибка обновления договора', error.response)
      })
    } else {
      axios.put(`${url}/partner/${id}`, contractorData, config).then(response => {
        router.push({ name: 'ContractorList' })
      }).catch(error => {
        commit('SET_CONTRACTOR_ITEM_VALIDATION', error.response.data.validation)
        console.log('Ошибка обновления договора', error.response.data.validation)
      })
    }
  },
  getContractorAllOptions ({ commit, state }) {
    const getContractorsStatusesList = function () {
      return axios.get(`${url}/partner-status`, config)
    }
    const getContractorsFormsList = function () {
      return axios.get(`${url}/partner-legal-form`, config)
    }
    const getContractorsTypesList = function () {
      return axios.get(`${url}/partner-type`, config)
    }

    axios.all([
      getContractorsStatusesList(),
      getContractorsFormsList(),
      getContractorsTypesList()
    ]).then(axios.spread((
      contractorStatusListResponse,
      contractorFormsListResponse,
      contractorTypesListResponse
    ) => {
      commit('GET_CONTRACTOR_STATUSES_LIST', contractorStatusListResponse.data)
      commit('GET_CONTRACTOR_FORMS_LIST', contractorFormsListResponse.data)
      commit('GET_CONTRACTOR_TYPES_LIST', contractorTypesListResponse.data)
    })).catch(error => {
      console.log('Ошибка получения списочных данных во время инициализации', error)
    })
  },
  setContractorUpdateInitialState ({ commit, state }) {
    commit('SET_CONTRACTOR_UPDATE_INITIAL_STATE', state)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
